(function () {
  function init() {
    var status = document.querySelector('[data-ocu-collection-status]');
    if (!status || status.dataset.ocuResultsReady) return;
    var container = status.closest('.col-main');
    if (!container) return;
    status.dataset.ocuResultsReady = 'true';
    var timer;
    var selector = '[data-ocu-collection-count]';
    new MutationObserver(function (records) {
      var replaced = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
        });
      });
      if (!replaced) return;
      var grid = container.querySelector(selector);
      if (!grid) return;
      var count = grid.getAttribute('data-ocu-collection-count');
      if (!/^\d+$/.test(count)) return;
      var key = count === '0' ? 'data-zero' : count === '1' ? 'data-one' : 'data-many';
      var message = status.getAttribute(key).replace('__COUNT__', count);
      clearTimeout(timer);
      status.textContent = '';
      timer = setTimeout(function () { status.textContent = message; }, 100);
    }).observe(container, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
